"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateCustomPackingSlipHTMLV2 = void 0;
const moment_1 = __importDefault(require("moment"));
const homi_shared_1 = require("@getgreenline/homi-shared");
const models_1 = require("../models");
const CreatePaymentLine_1 = require("@getgreenline/homi-shared/dist/models/Payments/CreatePaymentLine");
const generateReceiptHTMLV2_1 = require("./generateReceiptHTMLV2");
const packingSlipHelpers_1 = require("./packingSlipHelpers");
// NOTE: This is using the new receipt settings
const generateCustomPackingSlipHTMLV2 = (packingSlipData, receiptSettings, fontSize) => {
    const { company, customerPhone, locationName, deviceId, payment } = packingSlipData;
    const { subHeader, description, address, showSku } = receiptSettings;
    if (!payment) {
        return;
    }
    const headerText = (0, generateReceiptHTMLV2_1.getCustomReceiptHeader)(receiptSettings, company.name, locationName);
    const customerName = (0, packingSlipHelpers_1.getCustomerName)(payment);
    const completeDate = payment.status === homi_shared_1.PaymentQueueStatus.COMPLETED && payment.completedPayment
        ? payment.completedPayment.completeDate
        : null;
    const isPaid = 'completedPayment' in payment ? 'Paid' : 'Unpaid';
    const paymentData = {
        customId: (0, packingSlipHelpers_1.getCustomId)(payment),
        createDate: 'createDate' in payment ? payment.createDate : null,
        completeDate,
    };
    const paymentLines = payment.paymentLines;
    const notes = 'paymentQueueNotes' in payment && payment.paymentQueueNotes
        ? payment.paymentQueueNotes
        : payment.notes;
    const wordWrapStyle = 'white-space: pre-line; overflow-wrap: break-word; word-break: break-word;';
    return `
  <div id='print-section' style='padding-left: 10px; padding-right: 10px;'>
    <table 
      style='width: 100%;
      border: none;
      border-width: 0;
      border-collapse: collapse;
      padding: 0;
      ${fontSize ? 'font-size: ' + fontSize + ';' : ''}'
    >
      <tbody>
        <tr>
          <td colspan=2; style='font-weight: 600; ${wordWrapStyle}'>
            ${receiptSettings.headerOption !== models_1.RECEIPT_HEADER_OPTIONS.USE_COMPANY_NAME
        ? company.name
        : ''}
          </td>
          <td style='padding-left: 12px; text-align: right;'>
            <b>${isPaid}</b>
          </td>
        </tr>

        ${headerText
        ? `
              <tr>
                <td colspan=3 style='text-align: center; font-weight: 600; font-size: 1.5em; ${wordWrapStyle}'>${headerText}</td>
              </tr>
              `
        : ''}

        ${subHeader
        ? `
              <tr>
                <td colspan=3 style='text-align: center; font-weight: 600; ${wordWrapStyle}'>${subHeader}</td>
              </tr>
              `
        : ''}

        ${description
        ? `
              <tr>
                <td 
                  colspan=3;
                  style='margin-bottom: 20px;
                  text-align: center;
                  ${wordWrapStyle}
                  '
                >${description}</td>
              </tr>
              `
        : ''}

        ${address
        ? `
              <tr>
                <td colspan=3 style='text-align: center; ${wordWrapStyle}'>${address}</td>
              </tr>
              `
        : ''}
      </tbody>
    </table>

    <table 
      style='margin-top: 1.5rem;
      width: 100%;
      border: none;
      border-width: 0;
      border-collapse: collapse;
      padding: 0;
      ${fontSize ? 'font-size: ' + fontSize + ';' : ''}'
    >
      <tbody>
        ${paymentData.customId
        ? `<tr>
                  <td style='border-top: solid; border-width: 1px; '>Order ID</td>
                  <td style='border-top: solid; border-width: 1px;  text-align: right'>${paymentData.customId}</td>
                </tr>`
        : ''}

        ${paymentData.completeDate
        ? `
                <tr>
                  <td style='border-top: solid; border-width: 1px;'>Completed</td>
                  <td style='border-top: solid; border-width: 1px; text-align: right'>
                    ${(0, moment_1.default)(paymentData.completeDate).format('lll')}
                  </td>
                </tr>
              `
        : `
                <tr>
                  <td style='border-top: solid; border-width: 1px; '>Created</td>
                  <td style='border-top: solid; border-width: 1px;  text-align: right'>
                    ${(0, moment_1.default)(paymentData.createDate).format('lll')}
                  </td>
                </tr>
              `}

        <tr>
          <td style='border-top: solid; border-width: 1px;'>POS</td>
          <td style='border-top: solid; border-width: 1px; text-align: right'>
            ${deviceId || '-'}
          </td>
        </tr>

        ${customerName
        ? `
                  <tr>
                    <td style='border-top: solid; border-width: 1px; '>Customer</td>
                    <td style='border-top: solid; border-width: 1px;  text-align: right'>${customerName}</td>
                  </tr>
                `
        : ''}

        ${customerPhone
        ? `
                  <tr>
                    <td style='border-top: solid; border-width: 1px; '>Phone #</td>
                    <td style='border-top: solid; border-width: 1px;  text-align: right'>${customerPhone}</td>
                  </tr>
                `
        : ''}
      </tbody>
    </table>

    <table 
      style='margin-top: 1.5rem;
      width: 100%;
      border: none;
      border-width: 0;
      border-collapse: collapse;
      padding: 0;
      ${fontSize ? 'font-size: ' + fontSize + ';' : ''}'
    >
      <tbody>
        <tr>
          <td><b>Product</b></td>
          <td style='text-align: right'><b>Qty</b></td>
          <td style='text-align: right'><b>Price</b></td>
        </tr>
        ${paymentLines
        .map((paymentLine) => {
        const { productId, productName } = paymentLine;
        const quantity = paymentLine instanceof homi_shared_1.CreatePaymentLine ||
            paymentLine instanceof CreatePaymentLine_1.CreateGiftCardPaymentLine
            ? paymentLine.units
            : paymentLine.quantity;
        if (!productId && productName) {
            return `
                  <tr>
                    <td style='border-top: solid; border-width: 1px;'>
                      <div class='d-flex' style='flex-direction: column;'>
                        <div>${paymentLine.productName}</div>
                        ${``}
                        ${paymentLine.discountMessage
                ? `<div style='font-size: .9em'>${paymentLine.discountMessage}</div>`
                : ``}
                      </div>
                    </td>
                    <td 
                      style='border-top: solid;
                      border-width: 1px;
                      padding-right:.5rem;
                      text-align: right'
                    >${quantity}</td>
                    <td 
                      style='border-top: solid;
                      border-width: 1px;
                      text-align: right'
                    >
                      ${paymentLine.discountPrice
                ? (0, homi_shared_1.formatCurrencyFromCents)(paymentLine.discountPrice * quantity)
                : '$0.00'}
                    </td>
                  </tr>
                `;
        }
        if (!productId)
            return;
        const unitString = quantity.toString();
        let price = 0;
        if (paymentLine instanceof homi_shared_1.CreatePaymentLine ||
            paymentLine instanceof CreatePaymentLine_1.CreateGiftCardPaymentLine) {
            price = paymentLine.pricePerUnit || 0;
        }
        else {
            price = (paymentLine.price || 0) / quantity;
        }
        if (paymentLine.discountPrice < 0 || paymentLine.discountPercentage > 0) {
            return `
                  <tr>
                    <td style='border-top: solid; border-width: 1px;'>
                      <div class='d-flex' style='flex-direction: column;'>
                        <div>${paymentLine.productName}</div>
                        ${showSku && paymentLine.sku
                ? `<div style='font-size:.8em'>SKU: ${paymentLine.sku}</div>`
                : ``}

                        ${paymentLine.discountMessage
                ? `<div style='font-size: .9em'>${paymentLine.discountMessage}</div>`
                : ``}
                      </div>
                    </td>

                    <td 
                      style='border-top: solid;
                      border-width: 1px;
                      padding-right:.5rem;
                      text-align: right'
                    >${unitString}</td>

                    <td 
                      style='border-top: solid;
                      border-width: 1px;
                      text-align: right'
                    >
                      ${paymentLine ? (0, homi_shared_1.formatCurrencyFromCents)(price * quantity) : '$0.00'}
                    </td>
                  </tr>

                  ${paymentLine.discountPrice &&
                `
                      <tr>
                        <td>${paymentLine.discountMessage
                    ? paymentLine.discountMessage
                    : `${(0, homi_shared_1.formatCurrencyFromCents)(Math.abs(paymentLine.discountPrice))} off`}</td>
                        <td></td>
                        <td style='text-align: right;'>${(0, homi_shared_1.formatCurrencyFromCents)(paymentLine.discountPrice)}</td>
                      </tr>
                    `}
                `;
        }
        else {
            return `
                  <tr>
                    <td style='border-top: solid; border-width: 1px; '>
                      <div class='d-flex' style='flex-direction: column;'>
                        <div>${paymentLine.productName}</div>
                        ${showSku && paymentLine.sku
                ? `<div style='font-size:.8em'>SKU: ${paymentLine.sku}</div>`
                : ``}
                        ${paymentLine.discountMessage
                ? `<div style='font-size: .9em'>${paymentLine.discountMessage}</div>`
                : ``}
                      </div>
                    </td>

                    <td 
                      style='border-top: solid;
                      border-width: 1px;
                      padding-right:.5rem;
                      text-align: right'
                    >${unitString}</td>

                    <td 
                      style='border-top: solid;
                      border-width: 1px;
                      text-align: right'
                      >
                      ${paymentLine ? (0, homi_shared_1.formatCurrencyFromCents)(price * quantity) : '$0.00'}
                    </td>
                  </tr>

                  ${paymentLine.discountPrice
                ? `
                      <tr>
                        <td>${paymentLine.discountMessage}</td>
                        <td></td>
                        <td style='text-align: right;'> ${(0, homi_shared_1.formatCurrencyFromCents)(paymentLine.discountPrice)}</td>
                      </tr>
                    `
                : ''}
                  `;
        }
    })
        .join('')}
      </tbody>
    </table>

    <table 
      style='margin-top: 1.5rem;
      width: 100%;
      border: none;
      border-width: 0;
      border-collapse: collapse;
      padding: 0;
      ${fontSize ? 'font-size: ' + fontSize + ';' : ''}'
    >
      <tbody>
        ${notes
        ? `
                <tr>
                  <td><b>Notes</b></td>
                </tr>
                <tr>
                  <td 
                    colspan=3;
                    style='border-top: solid;
                    border-width: 1px;
                    margin-bottom: 20px;
                    text-align: center;
                    ${wordWrapStyle}
                    '
                  >${notes}</td>
                </tr>
                `
        : ''}
      </tbody>
    </table>
  </div>
  `;
};
exports.generateCustomPackingSlipHTMLV2 = generateCustomPackingSlipHTMLV2;
//# sourceMappingURL=generatePackingSlipHTMLV2.js.map